import Tooltip from '@mui/material/Tooltip';
import Stack from '@mui/material/Stack';
import { AgencyStaffAvatar, Avatar as DefaultAvatar, FacilityStaffAvatar } from '../../atoms/dataDisplay/avatar';
import { Box, Typography } from '@mui/material';
import { FaIcon } from '../../atoms/icons';

type UserRecord = {
  id: string;
  name: string;
  avatar?: string;
  isInternal?: boolean;
  isOriented?: boolean;
};

type AvatarListProps = {
  list: UserRecord[];
  borderBgColor?: string;
};
export function AvatarList({ list }: AvatarListProps) {
  // const { Avatar: LocalAvatar = DefaultAvatar } = slots ?? {};
  // To be able to show overlapped images in the correct order
  const reversedList = [...list].reverse();
  const first4items = reversedList.slice(0, 4);
  const extraItems = reversedList.slice(4);
  const extraNumber = extraItems.length;
  const extraNames = extraItems.map((item) => item.name).join(', ');

  if (first4items.length === 1) {
    return (
      <Stack direction="row" alignItems={'center'} spacing={1} paddingLeft={1} paddingTop={0.5} paddingBottom={0.5}>
        <Avatar userRecord={first4items[0]} />
        <Typography variant="body2">{first4items[0]?.name}</Typography>
      </Stack>
    );
  }

  return (
    // direction="row-reverse" To be able to show overlapped images in the correct order
    <Stack
      direction="row-reverse"
      spacing={-1}
      alignItems={'center'}
      paddingLeft={1}
      paddingTop={0.5}
      paddingBottom={0.5}
    >
      {extraNumber > 0 && (
        <Tooltip title={extraNames} placement="bottom" arrow>
          <DefaultAvatar
            alt={extraNames}
            sx={{
              width: 32,
              height: 32,
              fontSize: 12,
            }}
          >
            +{extraNumber}
          </DefaultAvatar>
        </Tooltip>
      )}
      {first4items.map((item) => {
        return <Avatar key={item.id} userRecord={item} />;
      })}
    </Stack>
  );
}

type avatarProps = {
  userRecord: UserRecord;
  key?: string | number;
};
export function Avatar({ userRecord, key }: avatarProps) {
  const { id, name, avatar, isInternal, isOriented } = userRecord;
  const LocalAvatar =
    isInternal === true ? FacilityStaffAvatar : isInternal === false ? AgencyStaffAvatar : DefaultAvatar;
  const map = {
    [`ori: true, internal: true`]: '(Location oriented internal)',
    [`ori: false, internal: true`]: '(Internal)',
    [`ori: true, internal: false`]: '(Location oriented external)',
    [`ori: false, internal: false`]: '(External)',
  };

  const postfix = isInternal !== undefined ? map[`ori: ${!!isOriented}, internal: ${isInternal}`] || '' : '';

  return (
    <Box
      key={key}
      sx={{
        position: 'relative',
        ':hover': { zIndex: 1 },
      }}
    >
      <Tooltip title={`${name} ${postfix}`} placement="bottom" arrow>
        <LocalAvatar
          src={avatar}
          alt={name}
          sx={(theme) => ({
            width: 32,
            height: 32,
            fontSize: 12,
            // border: `2px solid ${borderBgColor ?? theme.palette.background.paper}`,
            boxSizing: 'content-box',
          })}
          fullName={name}
        />
      </Tooltip>
      {isOriented && (
        <Box
          sx={{
            position: 'absolute',
            top: -24,
            left: 18,
          }}
        >
          <FaIcon
            name="square-check"
            color={'#4caf50'}
            variant="solid"
            style={{
              fontSize: '14px',
              backgroundColor: '#fff',
              borderRadius: '50%',
              width: '16px',
              height: '16px',
            }}
          />
        </Box>
      )}
    </Box>
  );
}
